module.exports = __webpack_public_path__ + "assets/img/dayu_shop_right.b65d0173.png";